import React, { useEffect, useState } from 'react'
import Table from 'UI/Table'
import Select from 'UI/Select'
import useOptions from './useOptions'
import useFilters from './useFilters'
import useColumns from './useColumns'
import DeletePopup from './DeletePopup'
import { Tabs, Tab } from 'react-bootstrap'
import CustomTab from './Tab'
import useErrorsCount from './useErrorsCount'
import CallbackIssues from "./CallbackIssues"
import CreatePopup from './CreatePopup'
import AffectedAssets from './AffectedAssets/index'
import ImportAudits from './ImportAudits/index'

const ImportConfiguration = ({ data: dataProps, canDestroy }) => {
  const [data, setData] = useState(dataProps)
  const [tab, setTab] = useState('imports')
  const [importIDToRemove, setImportIDToRemove] = useState(null)
  const [importConfigurationToCreate, setImportConfigurationToCreate] = useState(null)

  const options = useOptions(data)
  const [filters, setFilters] = useFilters(dataProps, setData, tab)

  const subComponent = (row) => {
    if (isImportTabActive) return <AffectedAssets configID={row.original.id} />
    else if (isNewFileTabActive) return <ImportAudits id={row.original.id} />
    else if (isCallbackTabActive) return <CallbackIssues id={row.original.id} />
    else null
  }

  const columns = useColumns({
    setImportIDToRemove,
    canDestroy,
    tab,
    setImportConfigurationToCreate
  })

  const isImportTabActive = tab === 'imports'
  const isCallbackTabActive = tab === 'callbacks'
  const isNewFileTabActive = tab === 'new_files'

  const errorsCount = useErrorsCount(dataProps)

  useEffect(() => {
    setFilters('resource', null)
    setFilters('location', null)
    setFilters('customer', null)
    setFilters('isCompliant', null)
    setFilters('isAuditSuccessful', null)
    setFilters('isGatheredToday', null)
    setFilters('isCheckedToday', null)
  }, [tab])

  return (
    <div>
      <DeletePopup
        setImportID={setImportIDToRemove}
        importID={importIDToRemove}
      />

      <CreatePopup
        setImportConfiguration={setImportConfigurationToCreate}
        importConfiguration={importConfigurationToCreate}
      />

      <div className="flex mb-4">
        <div className="mr-4">
          <label className="flex text-gray-700 text-sm leading-none">Resource</label>
          <Select
            isClearable
            options={options.resources}
            value={filters.resource}
            onChange={value => setFilters('resource', value)}
          />
        </div>

        <div className="mr-4">
          <label className="flex text-gray-700 text-sm leading-none">Location</label>
          <Select
            isClearable
            options={options.locations}
            value={filters.location}
            onChange={value => setFilters('location', value)}
            isDisabled={!isImportTabActive}
          />
        </div>

        <div className="mr-4">
          <label className="flex text-gray-700 text-sm leading-none">Customer</label>
          <Select
            isClearable
            options={options.customers}
            value={filters.customer}
            onChange={value => setFilters('customer', value)}
            isDisabled={isNewFileTabActive}
          />
        </div>

        <div className="mr-4">
          <label className="flex text-gray-700 text-sm leading-none">Compliant?</label>
          <Select
            isClearable
            options={options.booleans}
            value={filters.isCompliant}
            onChange={value => setFilters('isCompliant', value)}
            isDisabled={!isImportTabActive}
          />
        </div>

        <div className="mr-4">
          <label className="flex text-gray-700 text-sm leading-none">Audit Successful?</label>
          <Select
            isClearable
            options={options.booleans}
            value={filters.isAuditSuccessful}
            onChange={value => setFilters('isAuditSuccessful', value)}
          />
        </div>

        <div className="mr-4">
          <label className="flex text-gray-700 text-sm leading-none">Gathered Today?</label>
          <Select
            isClearable
            options={options.booleans}
            value={filters.isGatheredToday}
            onChange={value => setFilters('isGatheredToday', value)}
          />
        </div>

        <div>
          <label className="flex text-gray-700 text-sm leading-none">Checked Today?</label>
          <Select
            isClearable
            options={options.booleans}
            value={filters.isCheckedToday}
            onChange={value => setFilters('isCheckedToday', value)}
            isDisabled={!isImportTabActive}
          />
        </div>
      </div>

      <Tabs activeKey={tab} onSelect={setTab}>
        <Tab
          eventKey='imports'
          title={<CustomTab title="Imports" errorsCount={errorsCount.imports} />}
        />

        <Tab
          eventKey='callbacks'
          title={<CustomTab title="Callbacks" errorsCount={errorsCount.callbacks} />}
        />

        <Tab
          eventKey='new_files'
          title={<CustomTab title="New Files" errorsCount={errorsCount.newFiles} />}
        />
      </Tabs>

      <Table
        data={data}
        columns={columns}
        SubComponent={subComponent}
      />
    </div>
  )
}

export default ImportConfiguration
